import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';
import { useSnackbar } from 'notistack';

import FinancialService from '@services/FinancialService';

import { toastifyApiErrors } from '@utils';
import { useAuth } from '@hooks';

export function useIncomeReportPrint(year?: number) {
  const { enqueueSnackbar } = useSnackbar();
  const { selectedPartnerCompany } = useAuth();

  const financialService = useMemo(() => new FinancialService(), []);

  const partnerCompany = selectedPartnerCompany?.partnerCompany ?? '';
  const isValidYear = typeof year === 'number' && !Number.isNaN(year);
  const enabled = Boolean(partnerCompany && isValidYear);

  const incomeReportPrintState = useQuery({
    queryKey: ['incomeReportPrintState', partnerCompany, year],
    queryFn: () =>
      financialService.getIncomeReportPrint({
        partnerCompany,
        year: year!,
      }),
    enabled,
    onError: error => {
      toastifyApiErrors(error, enqueueSnackbar);
    },
  });

  const refreshIncomeReportPrint = () => {
    incomeReportPrintState.refetch();
  };

  return {
    incomeReportPrintState,
    refreshIncomeReportPrint,
  };
}
